import axios from "./axios";

export const getJobOfferCheckoutSession = (offerId) => {
  return axios.get(`/jobs/offers/${offerId}/checkout-session`);
};
export const bypassOfferPayment = (payload) => { 
  return axios.post(`/orders/bypass-order`, payload);
} 